import { Schema } from '@core/data/dto/schema';

export const DeliveryOrdersSummarySchema = {
    total_count: Schema.Number,
    total_sales: Schema.Number,
    total_tips: Schema.Number,
    total_accepted: Schema.Number,
    total_assigned: Schema.Number,
    total_canceled: Schema.Number,
    total_delivered: Schema.Number,
    total_dropoff: Schema.Number,
    total_new: Schema.Number,
    total_pickup: Schema.Number,
    total_rejected: Schema.Number,
    total_returned: Schema.Number,
    total_returning: Schema.Number,
    total_scheduled: Schema.Number,
    avg_delivery_fee: Schema.Number,
    avg_delivery_fee_gap: Schema.Number,
    avg_distance: Schema.Number,
};
